/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 26/10/2023
 */

import React from 'react'
import styles from "./Details.module.css"
import { Grid, Typography } from '@mui/material'

const info = [
    {id: 1, image: require("../../Assets/star.png"), title: 'We are Professional', description: 'Our reliable, friendly and efficient cleaning teams are well trained in all required domestic and housekeeping tasks.'},
    {id: 3, image: require("../../Assets/shield.png"), title: 'We Care', description: 'We ensure our housekeepers are covered for public liabilities to eliminate risk factors to your property.'},
    {id: 4, image: require("../../Assets/people.png"), title: 'We take responsibility', description: 'We take responsibility and seriously consider your safety and security and possesses only with housekeepers  passed valid police checks and clearance.'},
]

const Details = () => {
    return (
        <div >
<Grid container className={styles.container} rowSpacing={0} columnSpacing={2}>                {info.map(data => (
                    <Grid key={data.id} item xs={12} md={4} >
                        <div className={styles.cardContainer}>
                            <img className={styles.icon} src={data.image} alt={data.title} loading='lazy' />
                            <Typography className={styles.title} variant='h2'>{data.title}</Typography>
                            <Typography className={styles.description}>{data.description}</Typography>
                        </div>
                    </Grid>
                ))}
            </Grid>
        </div>
    )
}

export default Details